import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { EditOrganizationProfileModal } from 'works/components/edit-organization-profile';
import { Icon } from '@common/components';
import { toUSFormat } from 'works/legacy/lib/date-helper';
import moment from 'moment';

export default function EditArrivalDate({
  estimatedArrivalDate,
  arrivedAtDate,
  organizationProfileId,
  canUpdate,
}) {
  const [showOrganizationProfileModal, setShowOrganizationProfileModal] =
    useState(false);

  const formattedEstimatedArrivalDate = estimatedArrivalDate
    ? toUSFormat(estimatedArrivalDate)
    : null;
  const formattedArrivedAtDate = arrivedAtDate
    ? toUSFormat(arrivedAtDate)
    : null;
  const openEditModalOnClick = (children) => (
    <a onClick={() => setShowOrganizationProfileModal(true)}>{children}</a>
  );

  const hasArrived = moment(arrivedAtDate).isBefore();

  return (
    <>
      <EditOrganizationProfileModal
        visible={showOrganizationProfileModal}
        onClose={() => setShowOrganizationProfileModal(false)}
        organizationProfileId={organizationProfileId}
      />
      {formattedArrivedAtDate && (
        <Col>
          <Icon
            icon="planeArrival"
            kind="light"
            size="sm"
            tooltipText="Arrived At"
          />
          {hasArrived ? 'Arrived: ' : 'Arrival Date: '}
          {canUpdate
            ? openEditModalOnClick(formattedArrivedAtDate)
            : formattedArrivedAtDate}
        </Col>
      )}
      {!hasArrived && formattedEstimatedArrivalDate && (
        <Col>
          <Icon
            icon="planeArrival"
            kind="light"
            size="sm"
            tooltipText="Estimated Arrival Date"
          />
          {'Est. Arrival: '}
          {canUpdate
            ? openEditModalOnClick(formattedEstimatedArrivalDate)
            : formattedEstimatedArrivalDate}
        </Col>
      )}
      {!formattedArrivedAtDate && !formattedEstimatedArrivalDate && (
        <Col>
          <Icon
            icon="planeArrival"
            kind="light"
            size="sm"
            tooltipText="Estimated Arrival Date"
          />
          {canUpdate
            ? openEditModalOnClick('Est. Arrival Date TBD')
            : 'Est. Arrival Date TBD'}
        </Col>
      )}
    </>
  );
}

EditArrivalDate.propTypes = {
  organizationProfileId: PropTypes.string.isRequired,
  estimatedArrivalDate: PropTypes.string,
  arrivedAtDate: PropTypes.string,
  canUpdate: PropTypes.bool,
};

EditArrivalDate.defaultProps = {
  canUpdate: false,
};
